// API 配置 - 调试时可修改下方 baseURL 为本地地址，如 http://localhost:5001
const baseURL = 'https://api.eainfor.com'

export default {
  baseURL
}
